// export const auth_key = 'home_auth';
// export const url = 'http://127.0.0.1:9000';
// export const root = url + '/home';
// export const aliyun = 'http://cusprpc2019.oss-cn-beijing.aliyuncs.com';

// // 宝塔
// export const auth_key = 'admin_auth';
// export const url = 'http://diqijie.zjzhijie.com';
// export const aliyun = 'http://cusprpc2019.oss-cn-beijing.aliyuncs.com';
// const devServer = url+'/home';
// const proServer = '//diqijie.zjzhijie.com/index.php?s=/home';
// export const root = process.env.NODE_ENV === 'production' ? proServer : devServer;

// 官网
export const auth_key = 'home_auth';
export const url = 'http://cusprpc2019.cipra.org.cn';
export const aliyun = 'http://cusprpc2019.oss-cn-beijing.aliyuncs.com';
const devServer = url+'/home';
// 线上服务器
const proServer = '//cusprpc2019.cipra.org.cn/index.php?s=/home';
export const root = process.env.NODE_ENV === 'production' ? proServer : devServer;
